import axios from 'axios'
import store from '@state/store'

const units = {
  ms: {
    lengthMeasure: 'millimeters',
    lengthMultiplier: 1,
    volumeMeasure: 'liters',
    volumeMultiplier: 1000,
    densityMeasure: 'g_to_cm',
    densityMultiplier: 1000,
    firstDayOfWeek: 1,
  },
  us: {
    lengthMeasure: 'inches',
    lengthMultiplier: 25.4,
    volumeMeasure: 'us_gallon',
    volumeMultiplier: 3785.411784,
    densityMeasure: 'pound_gallon',
    densityMultiplier: 8345.404,
    firstDayOfWeek: 0,
  },
  is: {
    lengthMeasure: 'inches',
    lengthMultiplier: 25.4,
    volumeMeasure: 'imperial_gallon',
    volumeMultiplier: 4546.09,
    densityMeasure: 'pound_to_inches',
    densityMultiplier: 36.12729,
    firstDayOfWeek: 1,
  }
}

export const state = {
  userSettings: {},
}

export const getters = {
  getUnitsMeasurement(state) {
    return units[state.userSettings.unitsMeasurement]
  },
  get: state => path => {
    return state.userSettings[path]
  },
}

export const mutations = {
  SET_ALL(state, payload) {
    if (payload) {
      let result = {}
      for (const settings of payload) {
        result[settings.key] = settings.value
      }
      state.userSettings = result
    }
  },
  SET_USER_SETTINGS(state, payload) {
    state.userSettings= {...state.userSettings, [payload.key]: payload.value}
  },
}

export const actions = {
  loadUserSettings({commit, dispatch}) {
    axios.get(`/api/1/user/${store.state.auth.user.sub}/property`, {}).then(response => {
      commit('SET_ALL', response.data)
    })
  },
  setUserSettings({ state, commit }, payload) {
    return axios
    .put(`/api/1/user/${store.state.auth.user.sub}/property`, {
      key: payload.key,
      value: payload.value,
    })
    .then(response => {
      const {key, value} = response.data;
      commit('SET_USER_SETTINGS', {key: key, value: value})
      return true
    })
  },
}




